import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import Breadcrumb from '../services/Breadcrum.js';
import YouTubeVideos from './videos.js'

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>ENT Videos in Delhi, India | Treatment Procedures, Doctor, Clinic</title>
            <meta name="description" content="Watch informative ENT videos from Delhi, India. Learn about treatments, procedures, and expert doctor insights at MedFirst ENT Centre." />
            <meta name="keywords" content="ENT videos, ENT Delhi videos, patient education ENT, ear nose throat videos, ENT procedure videos, health education videos" />
            <link rel="canonical" href="https://entdelhi.com/videos/" />
            <meta property="og:title" content="ENT Videos in Delhi, India | Treatment Procedures, Doctor, Clinic" />
            <meta property="og:description" content="Watch informative ENT videos from Delhi, India. Learn about treatments, procedures, and expert doctor insights at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <YouTubeVideos/>
        
      </main>
    </div>
  )
}
